module.exports = __webpack_public_path__ + "static/media/dispatcher.fec2dfcb.svg";